import React from 'react';
import videojs from "video.js"
import 'videojs-seek-buttons/dist/videojs-seek-buttons.css';
import 'videojs-seek-buttons';
import youtubeVideo from 'videojs-youtube/dist/Youtube.js';
import vimeoVideo from './vimeo/Vimeo.js';
import wistiaVideo from "./wistia/Wistia.js"
import vidyardVideo from "./vidyard/Vidyard.js"
import AuthService from 'src/utils/auth.service';

import PlaceholderEmptyMessage from 'src/components/placeholderEmptyMessage';

import 'video.js/dist/video-js.css';
import cx from 'classnames';
import styles from './styles.module.scss';

import _, { isEmpty } from 'lodash';
import AssetService from 'src/utils/asset.service.js';

const AssetNotFoundSvgIcon = '/images/404errorMessage.svg';

class VideoViewer extends React.Component {
  constructor(props) {
    super(props);

    var videoProperties = this._extractVideoProperties(this.props);

    videoProperties.controlBar = {
      pictureInPictureToggle: this.props.pictureInPictureToggle,
      fullscreenToggle: this.props.fullscreenToggle
     };

    var initialSegment = this.props.initialSegment;
    initialSegment = initialSegment ? Number(initialSegment) : 0;

    this.state = {
      ...videoProperties,
      initialSegment: initialSegment
    }

    this.startRange = 0;
    this.timeSpent = 0;
    this.isPlaying = false;

    this.currentRange = null;
  }

  componentDidMount() {
    this.loadPlayer(this.props);
  }

  componentWillReceiveProps(nextProps) {

    if (this.props.asset.id !== nextProps.asset.id ||
      _.get(this.props, "asset.metadata.modified_date") !== _.get(nextProps, "asset.metadata.modified_date")) {

      var videoProperties = this._extractVideoProperties(nextProps);

      this.setState({
        ...videoProperties
      }, () => {
        this.updatePlayerSource(nextProps);
      });
    }

    if (_.get(this.props, "account.subtitleEnabled")) {
      this.updateSubtitle(this.props, nextProps);
    }


  }

  updateSubtitle(previousProps, nextProps) {
    let previousSubtitle = _.get(previousProps, "asset.viewer.subtitle");
    let nextSubtitle = _.get(nextProps, "asset.viewer.subtitle");

    const assetChanged =
      previousProps.asset.id !== nextProps.asset.id ||
      _.get(previousProps, "asset.metadata.modified_date") !==
        _.get(nextProps, "asset.metadata.modified_date");

    if (assetChanged && nextSubtitle) {
      this.removeTextTrack();
      this.addTextTrack(nextSubtitle);
      return;
    }

    if (nextSubtitle && previousSubtitle !== nextSubtitle) {
      this.removeTextTrack();
      this.addTextTrack(nextSubtitle);
    }

    if (!previousSubtitle && nextSubtitle) {
      this.addTextTrack(nextSubtitle);
    }

    if (previousSubtitle && !nextSubtitle) {
      this.removeTextTrack();
    }
  }

  removeTextTrack() {
    if (this.player) {
      const textTracks = this.player.textTracks();
      for (let i = textTracks.length - 1; i >= 0; i--) {
        const track = textTracks[i];
        this.player.removeRemoteTextTrack(track);
      }
    }
  }

  addTextTrack(subtitle) {
    if (this.player) {

      this.player.addRemoteTextTrack({ src: subtitle, kind: 'captions', label: 'English', language: 'en', default: true, mode: 'showing' }, true);
      this.player.currentTime(0);

    }
  }

  recordNewSession(assetId) {
    var viewDate = new Date().getTime();

    this.props.recordSessionAnalyticsEvent({
      type: 100,
      eventDate: viewDate,
      asset: assetId
    })
  }



  loadPlayer(props) {
    if (this.timer) {
      clearInterval(this.timer);
    }

    var videoProperties = this._extractVideoProperties(props);
    videoProperties.html5 = {
      nativeTextTracks: false
    }

    this.player = videojs(this.videoNode, videoProperties, () => {
      console.log('onPlayerReady', this)

      //Start Session
      this.startRange = 0;
      this.endRange = 0;
      this.timeSpent = 0;
      this.isPlaying = false;

      if (this.state.initialSegment > 0 && (_.get(this.props, "asset.metadata.external_video_provider") != 'youtube')) {
        this.player.currentTime(this.state.initialSegment);
      }

    });

    if ( _.get(this.props, "asset.metadata.content_length") || 
    _.get(this.props, "asset.metadata.video_duration") > 10.00) {
      this.player.seekButtons({
        forward: 10,
        back: 10
      })
    }


    var source = { src: this.state.src, type: this.state.type };

    this.player.src(source)

    const { account, asset } = this.props;

    if (_.get(account, 'subtitleEnabled', true) && _.get(asset, "viewer.subtitle")) {
      this.player.addRemoteTextTrack({ src: _.get(asset, "viewer.subtitle"), kind: 'captions', label: 'English', language: 'en', default: true }, false);
    }

    this.player.on("timeupdate", (e) => {
      //console.log('timeupdate: ' + this.player.currentTime());
      var endRange = this.player.currentTime();
      
      if (!this.currentRange && (_.get(this.props, "asset.metadata.external_video_provider") == 'wistia')) {
        this.currentRange = this.props.captureNewVideoRange(this.player.currentTime());
      }

      if (this.currentRange && !this.player.paused()) {
        this.props.updateVideoRange(this.currentRange, endRange);
      }
    });

    this.player.on('playing', () => {
      console.log("Player is playing the video");

      if (this.currentRange) {
        this.props.updateVideoRange(this.currentRange, this.player.currentTime());
      } else {
        this.currentRange = this.props.captureNewVideoRange(this.player.currentTime());
      }

    });

    this.player.on('play', () => {
      
      if(!this.props.session && this.props.recordAnalytics) {
        this.recordNewSession(this.props.asset.id, this.props.session);
      }



      if (_.has(this.player, 'controlBar.seekForward')) {
        this.player.controlBar.seekForward.show();
      }

      if (_.has(this.player, 'controlBar.seekBack')) {
        this.player.controlBar.seekBack.show();
      }

      if (this.props.onVideoStateChange) {
        this.props.onVideoStateChange('playing');
      }
    });

    this.player.on('timeupdate', () => {

      if (_.has(this.player, 'controlBar.seekForward')) {
        this.player.controlBar.seekForward.show();
      }

      if (_.has(this.player, 'controlBar.seekBack')) {
        this.player.controlBar.seekBack.show();
      }

    });

    this.player.on('seeking', () => {
      console.log("Player started seeking");
    });

    this.player.on('seeked', () => {
      console.log("Player finished seeking at " + this.player.currentTime());

      this.currentRange = this.props.captureNewVideoRange(this.player.currentTime());
    });

    this.player.on('ended', () => {
      console.log("Player finished playing video");

      if (_.has(this.player, 'controlBar.seekForward')) {
        this.player.controlBar.seekForward.hide();
      }

      if (_.has(this.player, 'controlBar.seekBack')) {
        this.player.controlBar.seekBack.hide();
      }


      if (this.currentRange) {
        this.props.updateVideoRange(this.currentRange, this.player.currentTime());
        this.currentRange = null;
      }
    });

    this.player.on(['waiting', 'pause', 'stalled', 'suspend'], () => {
      this.isPlaying = false;

      console.log('waiting');

      
    });

    this.player.on('pause', () => {
      if (!this.player.seeking() && this.props.onCaptureFrame) { 
    
        this.isPlaying = false;

        this.captureFrame();

        if (this.props.onVideoStateChange) {
          this.props.onVideoStateChange('paused');
        }
      }
    });

    this.player.on('error', (e) => {
      console.log(e);
      var error = this.player.error();

      this.setState({
        error: error
      })
    });

    this.player.on('click', e => {
      var textTracks = this.player.textTracks();
      for (var i = 0; i < textTracks.length; i++) {
        var track = textTracks[i];
        if (track.label === "") {
          textTracks.removeTrack(track);
          break;
        }
      }
    });

    this.timer = setInterval(() => {
      this.syncRanges();
    }, 5000);
  }

   captureFrame(){
    const videoElement = this.videoNode;
  
    const canvas = document.createElement('canvas');
    canvas.width = videoElement.videoWidth;
    canvas.height = videoElement.videoHeight;

    const context = canvas.getContext('2d');
    context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

    const frameImage = canvas.toDataURL('image/jpeg');
    
    if (this.props.onCaptureFrame) {
      this.props.onCaptureFrame(frameImage);
    }
  };


  updatePlayerSource(props) {
    if (this.timer) {
      clearInterval(this.timer);
    }

    this.syncRanges();

    this.currentRange = null;
    this.startRange = 0;
    this.endRange = 0;
    this.timeSpent = 0;
    this.isPlaying = false;

    var videoProperties = this._extractVideoProperties(props);
    this.player.src(videoProperties);

    this.timer = setInterval(() => {
      this.syncRanges();
    }, 5000);
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose()
    }

    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  syncRanges() {
    this.props.ranges.forEach((range) => {

      var shouldRemove = false;
      var isCurrent = range.id == this.currentRange;

      var duration = range.end - range.start;
      var shouldSync = duration >= 2 && (!(range.synced || range.syncing));
      shouldRemove = !shouldSync && !isCurrent;

      if (shouldSync && this.props.session) {
        console.log('Sync with server' + range.id);
        var request = {
          type: 103,
          session: this.props.session,
          rangeId: range.external_id,
          start: range.start,
          end: range.end,
          eventDate: range.updatedDate
        }

        this.props.syncAssetVideoRange(range.id, request);
      }

      if (shouldRemove) {
        console.log('Remove from store' + range.id);
        this.props.removeVideoRange(range.id);
      }

    })
  }

  _extractExternalVideoProperties(props) {
    var videoDetail = {
      src: props.asset.metadata.url,
      type: _.get(props, "asset.metadata.external_video_type"),
    }
    if (_.get(props,"asset.metadata.external_video_provider")=="youtube" 
    && videoDetail.src && videoDetail.src.includes("/shorts/")){
    videoDetail.src = videoDetail.src.replace('/shorts/', '/watch?v=');
    }
    if (props.initialSegment > 0) {
      if (_.get(props, "asset.metadata.external_video_provider") === "youtube") {
        videoDetail.src = `${videoDetail.src}&start=${props.initialSegment}`;
      } else if (_.get(props, "asset.metadata.external_video_provider") === "vidyard") {
        videoDetail.src = `${videoDetail.src}?second=${props.initialSegment}`;
      }
    }
    return videoDetail;
  }

  _extractDefaultVideoProperties(props) {

    let videoUrl = AuthService.getURL(`api/2.0/assets/${props.asset.id}/download`, {
      modifiedDate: AssetService.getNumericValue(props.asset, "metadata.modified_date"),
      preview: true
    });

    let videoType = _.get(props, "asset.metadata.content_type")

    if (_.get(props, "asset.viewer.url")) {
      videoUrl = _.get(props, "asset.viewer.url")
    }

    if (_.get(props, "asset.viewer.contentType")){
      videoType = _.get(props, "asset.viewer.contentType")
    }

    var videoDetail = {
      src: videoUrl,
      type: videoType
    }

    return videoDetail;
  }

  _extractVideoProperties(props) {
    switch (_.get(props, "asset.metadata.external_video_provider")) {
      case 'youtube':
      case 'vimeo':
      case 'wistia':
      case 'vidyard':
        return this._extractExternalVideoProperties(props);
      default:
        return this._extractDefaultVideoProperties(props);
    }
  }

  render() {
    if (this.state.error) {
      return this._renderError();
    }

    var options = {
    };

    if (this.state.type != "video/wistia") {
      options["controls"] = "controls";
      options["data-setup"] = '{"playbackRates": [0.5, 1, 1.5, 2]}';
    }else if (this.state.type === "video/wistia") {
      options["data-setup"] = `{
        "loadingSpinner": false
      }`;
    }

    return (
      <div className={cx(styles.viewer)}>
        <div data-vjs-player>
          <video ref={node => this.videoNode = node}
            className={cx("vjs-16-9", "video-js", styles.vjs169, this.props.className)} crossOrigin="anonymous" {...options} >
          </video>
        </div>
      </div>
    );
  }

  _renderError() {
    if (this.state.error) {
      if (this.state.error.code == 1) {
        return (
          <PlaceholderEmptyMessage
            title="Playback Interrupted"
            message="Video playback failed. An unexpected interruption occurred."
            image={AssetNotFoundSvgIcon}
            className={styles.emptyMessage}
            visible={true}
          />
        );

      }
      else if (this.state.error.code == 2) {
        return (
          <PlaceholderEmptyMessage
            title="Network Connection Issue"
            message="Unable to load video due to a network issue. Please check your internet connection."
            image={AssetNotFoundSvgIcon}
            className={styles.emptyMessage}
            visible={true}
          />
        );

      }
      else if (this.state.error.code == 3) {
        return (
          <PlaceholderEmptyMessage
            title="Decoding Error"
            message="Error decoding video. Please ensure the file is in a compatible format."
            image={AssetNotFoundSvgIcon}
            className={styles.emptyMessage}
            visible={true}
          />
        );

      }
      else if (this.state.error.code == 4) {
        return (
          <PlaceholderEmptyMessage
            title="Unsupported Video Format"
            message="Unsupported video format or source. The player is unable to handle the content."
            image={AssetNotFoundSvgIcon}
            className={styles.emptyMessage}
            visible={true}
          />
        )
      }
      else if (this.state.error.code == 5) {
        return (
          <PlaceholderEmptyMessage
            title="Encryption Security Error"
            message="Video content is encrypted for security reasons. Playback is not possible."
            image={AssetNotFoundSvgIcon}
            className={styles.emptyMessage}
            visible={true}
          />
        );
      } else {
        return (
          <PlaceholderEmptyMessage
            title="Unknown Error"
            message="The player is unable to play the content"
            image={AssetNotFoundSvgIcon}
            className={styles.emptyMessage}
            visible={true}
          />
        );
      }
    }
  }
}

export default VideoViewer;